import { getStorage } from "./storage-utils";

const AuthUtil = {
    GetCurrentUser() {
        var userJson = getStorage("user") as string;
        if (!userJson) {
            window.location.href = "/logout";
            return null;
        }
        var user = JSON.parse(userJson);
        return userJson ? user : null;
    },

    IsAuthenticated() {
        var user = this.GetCurrentUser();
        if (user)
            return true;

        return false;
    },

    IsAdmin() {
        var user = this.GetCurrentUser();
        if (user && user.isAdmin)
            return true;

        return false;
    }
}

export default AuthUtil;